/** Сброс UI-состояния клиентского PWA после выхода (overflow, классы оболочки). */
export function resetClientAppChrome() {
  if (typeof document === "undefined") return;
  document.body.style.overflow = "";
  document.documentElement.classList.remove("client-app-mode");
}
